import { render, staticRenderFns } from "./supplier-assessment.vue?vue&type=template&id=ab78c1fe&scoped=true"
import script from "./supplier-assessment.vue?vue&type=script&lang=js"
export * from "./supplier-assessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab78c1fe",
  null
  
)

export default component.exports